import { render, staticRenderFns } from "./FileList.vue?vue&type=template&id=51fd6c0f&scoped=true&"
import script from "./FileList.vue?vue&type=script&lang=js&"
export * from "./FileList.vue?vue&type=script&lang=js&"
import style0 from "./FileList.vue?vue&type=style&index=0&id=51fd6c0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fd6c0f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51fd6c0f')) {
      api.createRecord('51fd6c0f', component.options)
    } else {
      api.reload('51fd6c0f', component.options)
    }
    module.hot.accept("./FileList.vue?vue&type=template&id=51fd6c0f&scoped=true&", function () {
      api.rerender('51fd6c0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/form/data/components/FileList.vue"
export default component.exports